export default {
  encuestaData: [],
  encuestaResponses: [],
  isLoading: false,
};
